import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "assets/jss/material-kit-react/views/RegisterPage.js";

import image from "assets/img/pinehurst.jpeg";
import { Auth } from "aws-amplify";

const useStyles = makeStyles(styles);

export default function RegisterPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const history = useHistory();

  const { ...rest } = props;
  const [loading, setLoading] = useState(false);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [pass, setpass] = useState("");
  const [confirmpass, setconfirmpass] = useState("");
  const [error, seterror] = useState(null);
  const [errorOpen, setErrorOpen] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passStrengthLabel, setStrengthLabel] = useState("");
  const [passwordClassChange, setPasswordClassChange] = useState(
    classes.strengthBar
  );

  const passwordMatch = () => pass === confirmpass;

  const isValid = useCallback(() => {
    if (name === "") {
      return false;
    }

    if (email === "") {
      return false;
    }

    if (confirmpass === "") {
      return false;
    }

    if (passwordStrength < 4) {
      return false;
    }

    return true;
  }, [name, email, confirmpass, passwordStrength]);

  const strengthChecker = () => {
    // We then change the badge's color and text based on the password strength
    let strongPassword = new RegExp(
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
    );
    let mediumPassword = new RegExp(
      "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))"
    );

    if (strongPassword.test(pass)) {
      setPasswordStrength(4);
      setStrengthLabel("strong");
      setPasswordClassChange(classes.perfect);
    } else if (mediumPassword.test(pass)) {
      setPasswordStrength(3);
      setStrengthLabel("normal");
      setPasswordClassChange(classes.strong);
    } else if (pass !== "" && pass.length > 6) {
      setPasswordStrength(2);
      setStrengthLabel("weak");
      setPasswordClassChange(classes.good);
    } else if (pass !== "") {
      setPasswordStrength(1);
      setStrengthLabel("too short");
      setPasswordClassChange(classes.weak);
    } else {
      setPasswordStrength(0);
      setStrengthLabel("");
      setPasswordClassChange(classes.strengthBar);
    }
  };
  const submitRegistration = (e) => {
    e.preventDefault();

    if (!passwordMatch()) {
      setErrorOpen(true);
      seterror("Confirm password should be matched with password.");
      return;
    }

    authenticationAWS();
  };

  const authenticationAWS = async () => {
    try {
      setLoading(true);
      const { user } = await Auth.signUp({
        username: name,
        password: pass,
        attributes: {
          email, // optional
        },
      });
      setLoading(false);
      history.push("./confirmcode", {
        username: name,
        userdata: user.userDataKey,
      });
    } catch (err) {
      setErrorOpen(true);
      seterror(err.message);
      setLoading(false);
    }

    //dispath to userActions
  };

  return (
    <div>
      <Header
        absolute
        color="transparent"
        brand="Claim System"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form
                  className={classes.form}
                  onSubmit={(event) => submitRegistration(event)}
                >
                  <CardHeader color="golf" className={classes.cardHeader}>
                    <h4>Register</h4>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="User Name"
                      id="name"
                      name="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => setname(e.target.value),
                        endAdornment: (
                          <InputAdornment position="end">
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      labelText="Email..."
                      id="email"
                      name="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "email",
                        onChange: (e) => setemail(e.target.value),
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      labelText="Password"
                      id="pass"
                      name="pass"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        onChange: (e) => setpass(e.target.value),
                        onKeyUp: () => strengthChecker(),
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                    />

                    <div className="password-strength">
                      <div
                        className={[
                          classes.strengthBar,
                          passwordClassChange,
                        ].join(" ")}
                      >
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <div className={classes.strengthLabel}>
                        {passStrengthLabel}
                      </div>
                    </div>

                    <CustomInput
                      labelText="Confirm Password"
                      id="confirmpass"
                      name="confirmpass"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        onChange: (e) => setconfirmpass(e.target.value),
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button
                      disabled={!isValid() || loading}
                      variant="contained"
                      color="primary"
                      type="submit"
                      fullWidth
                    >
                      <div>
                        {loading ? <CircularProgress size={"18px"} /> : ""}
                        Register
                      </div>
                    </Button>
                  </CardFooter>
                </form>
              </Card>
              {error ? (
                <Snackbar
                  variant="error"
                  key={error}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  open={errorOpen}
                  onClose={() => setErrorOpen(false)}
                  autoHideDuration={3000}
                >
                  <SnackbarContent
                    className={classes.error}
                    message={
                      <div>
                        <span style={{ marginRight: "8px" }}>
                          <ErrorIcon fontSize="large" color="error" />
                        </span>
                        <span> {error} </span>
                      </div>
                    }
                    action={[
                      <IconButton
                        key="close"
                        aria-label="close"
                        onClick={(e) => {
                          setErrorOpen(false);
                        }}
                      >
                        <CloseIcon color="error" />
                      </IconButton>,
                    ]}
                  />
                </Snackbar>
              ) : null}
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    </div>
  );
}
